import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, shape, string } from 'prop-types'

import heroImageSmall from 'images/discover/datasets/hero-500.webp'
import heroImage from 'images/discover/datasets/hero.avif'

import { FORM_ANCHOR_HREF } from '../../constants'

function Hero({ hero }) {
  return (
    <section className="datasets-hero">
      <div className="discover-container">
        <div className="datasets-hero__wrap">
          <div className="datasets-hero__content">
            <h1 className="datasets-hero__title discover-heading cgt-heading-500">{hero.title}</h1>
            <p className="datasets-hero__lead cgt-body-lg">{hero.lead}</p>
            <Button type="primary" size="large" href={FORM_ANCHOR_HREF} customClass="datasets-hero__button">
              {hero.cta}
            </Button>
          </div>
          <img
            className="datasets-hero__image"
            src={heroImage}
            srcSet={`${heroImageSmall} 500w, ${heroImage} 1160w`}
            sizes="(max-width: 959px) 100vw, 516px"
            width={1160}
            height={709}
            alt={hero.imageAlt}
            fetchpriority="high"
          />
        </div>
        <ul className="datasets-hero__stats">
          {hero.stats.map(stat => (
            <li key={stat.value} className="discover-stat">
              <p className="discover-stat__value">{stat.value}</p>
              <p className="discover-stat__label cgt-body-lg">{stat.label}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

Hero.propTypes = {
  hero: shape({
    title: string.isRequired,
    lead: string.isRequired,
    cta: string.isRequired,
    imageAlt: string.isRequired,
    stats: arrayOf(shape({ value: string.isRequired, label: string.isRequired })).isRequired,
  }).isRequired,
}

export default Hero
